const colorName: { [key: string]: string } = {
  hoverColor: 'rgba(25, 118, 210, 0.08)',
  primary: '#1E293B',
  editButton: 'linear-gradient(0deg, #1c1d1f , #5b5f67)',
  deleteButton: 'linear-gradient(0deg, #600002 ,rgb(166, 54, 56))',
  blueButton: 'linear-gradient(0deg, rgb(38 51 212), rgb(111 123 255))',
  greenButton: 'linear-gradient(0deg, #12512A, #02ac43)',
  yellowButton: 'linear-gradient(0deg, #12512A, #02ac43)',
  lightBlueButton: 'linear-gradient(0deg, rgb(239 245 253), rgb(255, 255, 255))',
  lightBlueGray900: '#121923',
  lightBlueGray800: '#1E293B',
  lightBlueGray700: '#334155',
  lightBlueGray600: '#475569',
  lightBlueGray500: '#64748B',
  lightBlueGray400: '#94A3B8',
  lightBlueGray300: '#CBD5E1',
  lightBlueGray200: '#E2E8F0',
  lightBlueGray100: '#F3F4F6',
  lightBlueGray50: '#F8FAFC',

  darkBlueGray900: '#06080C',
  darkBlueGray800: '#0C1018',
  darkBlueGray700: '#121923',
  darkBlueGray600: '#18212F',
  darkBlueGray500: '#1E293B',
  darkBlueGray400: '#334155',
  darkBlueGray300: '#475569',
  darkBlueGray200: '#64748B',
  darkBlueGray100: '#94A3B8',
  darkBlueGray50: '#C7D4E5',

  white: '#FFFFFF',

  red900: '#7A1616',
  red800: '#991B1B',
  red700: '#B91C1C',
  red600: '#DC2626',
  red500: '#EF4444',
  red400: '#F87171',
  red300: '#FCA5A5',
  red200: '#FECACA',
  red100: '#FEE2E2',
  red50: '#FEF2F2',

  orange900: '#7B2A0E',
  orange800: '#9A3412',
  orange700: '#C2410C',
  orange600: '#EA580C',
  orange500: '#F97316',
  orange400: '#FB923C',
  orange300: '#FDBA74',
  orange200: '#FED7AA',
  orange100: '#FFEDD5',
  orange50: '#FFF7ED',

  pink900: '#7E123E',
  pink800: '#9D174D',
  pink700: '#BE185D',
  pink600: '#DB2777',
  pink500: '#EC4899',
  pink400: '#F472B6',
  pink300: '#F9A8DD',
  pink200: '#FBCFE8',
  pink100: '#FCE7F3',
  pink50: '#FDF2F8',

  yellow900: '#6A3E0B',
  yellow800: '#854D0E',
  yellow700: '#A16207',
  yellow600: '#CA8A04',
  yellow500: '#EAB308',
  yellow400: '#FACC15',
  yellow300: '#FDE047',
  yellow200: '#FEF08A',
  yellow100: '#FEF9C3',
  yellow50: '#FEFCE8',

  green900: '#12512A',
  green800: '#166534',
  green700: '#15803D',
  green600: '#16A34A',
  green500: '#22C55E',
  green400: '#4ADE80',
  green300: '#86EFAC',
  green200: '#BBF7D0',
  green100: '#DCFCE7',
  green50: '#F0FDF4',

  blue900: '#18338C',
  blue800: '#1E40AF',
  blue700: '#1D4ED8',
  blue600: '#2563EB',
  blue500: '#3B82F6',
  blue400: '#60A5FA',
  blue300: '#93C5FD',
  blue200: '#BFDBFE',
  blue100: '#DBEAFE',
  blue50: '#EFF6FF',
};

export default colorName;
